import React from 'react';
import ServicePageLayout from './service/ServicePageLayout';
import customerInsightPropensityPageData from '../data/servicePages/customerInsightPropensity';

const CustomerInsightPropensityPage = () => <ServicePageLayout data={customerInsightPropensityPageData} />;

export default CustomerInsightPropensityPage;
